/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE_AP_CLOSURE_REPORTS = 'DITActionPlanClosures';
